import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import {compose} from 'redux';
import * as fonts from '../../../../util/fonts';

import {strings} from '../../../../util/strings';
import {addToGlobalStyles, addToWizard} from '../../../../store/actions';
import ModalTemplate from '../../../../components/modal/ModalTemplate';
import {Column, Row} from '../../../../components/layout';
import AppButton from '../../../../components/app-button';
import App from '../../../../App';
import colors from '../../../../util/colors';
import {labelsParagraphs} from '../../../../util/utility';
import AppParagraph from '../../../../components/app-paragraph';

interface PreAuthorizationPreRequestProps {
  labels: any;
  show: boolean;
  setShowModal(value: any): void;
}

function PreAuthorizationPreRequest({
  labels,
  show,
  setShowModal,
}: PreAuthorizationPreRequestProps) {
  // converts any '\r\n' in the labels to "<p></p>"
  labelsParagraphs(labels);

  return (
    <div className="pre-autorizacoes-modal-content p-0">
      <ModalTemplate
        show={show}
        onHide={() => setShowModal(false)}
        cross={true}
        hideFooter={true}>
        <Column>
          <Row className="pre-autorizacoes-title-row">
            <AppParagraph
              style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
              className="p-preautorizacoes"
              label={labels?.refund_preAuthorization_whenAddPreAuthorization}
            />
          </Row>
          <Row>
            <AppParagraph
              style={{...fonts.MM, ...fonts.Medium, color: colors.black}}
              className="p-preautorizacoes"
              label={labels?.refund_preAuthorizationRequest_firstTitle}
            />
          </Row>
          <Row>
            <AppParagraph
              style={{...fonts.M, ...fonts.Light, color: colors.black}}
              className="p-preautorizacoes"
              label={labels?.refund_preAuthorizationRequest_firstText}
            />
          </Row>
          <Row>
            <AppParagraph
              style={{...fonts.MM, ...fonts.Medium, color: colors.black}}
              className="p-preautorizacoes"
              label={labels?.refund_preAuthorizationRequest_secondTitle}
            />
          </Row>
          <Row>
            <AppParagraph
              style={{...fonts.M, ...fonts.Light, color: colors.black}}
              label={labels?.refund_preAuthorizationRequest_secondText}
            />
          </Row>
          <Row>
            <AppButton
              className="pre-autorizacoes-buttons"
              variant="secondary"
              style={{fontSize: 14}}
              onClick={() => setShowModal(false)}>
              {labels?.refund_preAuthorizationRequest_button}
            </AppButton>
          </Row>
        </Column>
      </ModalTemplate>
    </div>
  );
}

const mapStateToProps = ({selectedBu, user, strings, wizard}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.preAuthorizations,
  wizard: wizard.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(PreAuthorizationPreRequest)
);
